(() => {
  window.jcWishlistQuickBuyReady = window.customElements.whenDefined('quick-buy-modal').then(() => {
    const QuickBuyModal = window.customElements.get('quick-buy-modal');

    class WishlistQuickBuyModal extends QuickBuyModal {
      constructor() {
        super();
        this.addEventListener('submit', (event) => {
          if (!this._wishlistSelectionRequired) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('variant-picker input, variant-picker button')?.focus();
        }, true);
        const releaseSelection = (event) => {
          if (!event.isTrusted || !this._wishlistSelectionRequired) return;
          const picker = this.querySelector('variant-picker');
          const requiredOption = this.querySelector('.option_downcase-size') || picker;
          if (!requiredOption?.contains(event.target)) return;
          const option = event.target.closest('label[for], [data-option-value], input[type="radio"], select');
          const control = option?.tagName === 'LABEL' ? option.control : option;
          const disabled = () => !control || control.disabled || option?.closest('[aria-disabled="true"], .is-disabled, [hidden]') || control.getAttribute('aria-disabled') === 'true';
          if (!option || disabled()) return;
          const generation = this._wishlistSelectionGeneration;
          const attempt = this._wishlistSelectionAttempt = (this._wishlistSelectionAttempt || 0) + 1;
          let optionInput = control;
            if (control.matches('button')) {
              optionInput = control.closest('[data-option-selector]')?.querySelector('input[name^="option"], select[name^="option"]');
            }
            const position = optionInput?.name?.match(/^option(\d+)$/)?.[1];
            const requestedValue = control.matches('button') ? control.value : optionInput?.value;
            const activated = optionInput?.type !== 'radio' || optionInput.checked;


          setTimeout(async () => {
            try {
              const product = await this.getWishlistProduct(picker);
              if (!this.isConnected || generation !== this._wishlistSelectionGeneration || attempt !== this._wishlistSelectionAttempt || !this._wishlistSelectionRequired) return;
              const form = document.getElementById(picker.getAttribute('form'));
              if (position && (optionInput?.value !== requestedValue || optionInput.type === 'radio' && !optionInput.checked)) {
                const optionInputs = Array.from(picker.querySelectorAll('[name="option' + position + '"]'));
                const restoredOption = optionInputs.find((input) => input.type === 'radio' && input.value === requestedValue) || optionInputs.find((input) => input.tagName === 'SELECT' || input.type === 'hidden');
                if (restoredOption?.type === 'radio') restoredOption.checked = true;
                else if (restoredOption) restoredOption.value = requestedValue;
                restoredOption?.dispatchEvent(new Event('change', { bubbles: true }));
                optionInput = restoredOption || optionInput;
              }
              const variantId = form?.querySelector('input[name="id"]')?.value;
              const variant = product?.variants?.find((entry) => String(entry.id) === variantId);
              if (!this.isConnected || generation !== this._wishlistSelectionGeneration || attempt !== this._wishlistSelectionAttempt || !this._wishlistSelectionRequired || disabled() || !variant?.available || !position || !activated || variant[`option${position}`] !== requestedValue) return;
              if (form) form.dataset.sizeOptionChosen = 'true';
              this._wishlistSelectionRequired = false;
              this.querySelectorAll('.disabled_selected_block').forEach((element) => element.classList.remove('disabled_selected_block'));
              this.querySelectorAll('.select_size_btn').forEach((button) => {
                button.classList.remove('select_size_btn');
                button.textContent = button.dataset.wishlistOriginalLabel;
              });
            } catch (error) {
              this.dispatchEvent(new CustomEvent('wishlist:quick-buy-error', { bubbles: true, detail: { error } }));
            }
          }, 0);
        };
        this.addEventListener('change', releaseSelection, true);
        this.addEventListener('click', releaseSelection, true);
      }

      async getQuickBuyContent() {
        const context = this.getAttribute('data-wishlist-context');
        if (!context) return super.getQuickBuyContent();

        const requestId = this._wishlistRequestId = (this._wishlistRequestId || 0) + 1;
        this._wishlistRequest?.abort();
        const controller = this._wishlistRequest = new AbortController();
        const handle = this.getAttribute('handle');
        const preferredVariant = this.getAttribute('preferred-variant');
        const productUrl = `${window.Shopify.routes.root}products/${handle}`;
        const requestUrl = preferredVariant && /^\d+$/.test(preferredVariant) ? `${productUrl}?variant=${preferredVariant}` : productUrl;
        try {
          const response = await fetch(requestUrl, { cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Quick Buy product could not be loaded.');
          const tempDoc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const quickBuyContent = tempDoc.getElementById('quick-buy-content')?.content;
          if (!quickBuyContent) throw new Error('Quick Buy content is unavailable.');
          Array.from(quickBuyContent.querySelectorAll('noscript')).forEach((noScript) => noScript.remove());
          if (preferredVariant) {
            const variantInput = quickBuyContent.querySelector('form[is="product-form"] input[name="id"]');
            const purchaseButton = variantInput?.closest('form')?.querySelector('[type="submit"]');
            if (!/^\d+$/.test(preferredVariant) || variantInput?.value !== preferredVariant || !purchaseButton || purchaseButton.disabled) {
              throw new Error('The saved variant is unavailable for this product.');
            }
          }
          if (!this.isConnected || requestId !== this._wishlistRequestId) return null;
          this.namespaceWishlistContent(quickBuyContent, context);
          return quickBuyContent;
        } catch (error) {
          if (error.name === 'AbortError') return null;
          this.dispatchEvent(new CustomEvent('wishlist:quick-buy-error', { bubbles: true, detail: { error } }));
          return null;
        } finally {
          if (this._wishlistRequest === controller) this._wishlistRequest = null;
        }
      }

      onQuickBuyContentMounted() {
        super.onQuickBuyContentMounted();
        const context = this.getAttribute('data-wishlist-context');
        const preferredVariant = this.getAttribute('preferred-variant');
        this._wishlistSelectionGeneration = (this._wishlistSelectionGeneration || 0) + 1;
        const form = this.querySelector('form[is="product-form"]');
        const variantInput = form?.querySelector('input[name="id"]');
        const purchaseButton = form?.querySelector('[type="submit"]');
        const hasValidatedPreferredVariant = Boolean(preferredVariant && /^\d+$/.test(preferredVariant) && variantInput?.value === preferredVariant && purchaseButton && !purchaseButton.disabled);
        if (hasValidatedPreferredVariant) form.dataset.sizeOptionChosen = 'true';
        this._wishlistSelectionRequired = Boolean(context && (this.hasAttribute('require-selection') || !hasValidatedPreferredVariant && this.querySelector('.option_downcase-size')));
        if (!this._wishlistSelectionRequired) return;
        this.querySelectorAll('.option_downcase-size').forEach((element) => element.classList.add('disabled_selected_block'));
        this.querySelectorAll('form[is="product-form"] button[type="submit"]').forEach((button) => {
          button.dataset.wishlistOriginalLabel = button.textContent;
          button.classList.add('select_size_btn');
          button.textContent = this.getAttribute('data-wishlist-choose-options') || button.textContent;
        });
      }

      async show() {
        try {
          return await super.show();
        } catch (error) {
          if (!this.hasAttribute('data-wishlist-context')) throw error;
          this.dispatchEvent(new CustomEvent('wishlist:quick-buy-error', { bubbles: true, detail: { error } }));
        }
      }

      disconnectedCallback() {
        this._wishlistRequestId = (this._wishlistRequestId || 0) + 1;
        this._wishlistRequest?.abort();
        super.disconnectedCallback();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'id' && !this.isConnected) return;
        super.attributeChangedCallback(name, oldValue, newValue);
      }

      async getWishlistProduct(picker) {
        const product = picker.product || await picker.productReady;
        if (!product || picker.initializationComplete) return product;
        await new Promise((resolve, reject) => {
          const timer = setTimeout(() => {
            picker.removeEventListener('variant-picker:ready', onReady);
            reject(new Error('Wishlist variant picker did not initialize.'));
          }, 5000);
          const onReady = () => {
            clearTimeout(timer);
            resolve();
          };
          picker.addEventListener('variant-picker:ready', onReady, { once: true });
          if (picker.initializationComplete) onReady();
        });
        return picker.product || product;
      }

      namespaceWishlistContent(content, context) {
        const prefix = context.replace(/[^a-zA-Z0-9_-]/g, '-');
        content.querySelectorAll('a[href*="/products/"]').forEach((anchor) => {
          anchor.setAttribute('data-tcwl-done', 'wishlist');
          const card = anchor.closest('.card, .product-card, .grid__item, .product-item, li, article');
          if (card && content.contains(card)) card.setAttribute('data-tcwl-done', 'wishlist');
        });
        const ids = new Map();
        content.querySelectorAll('[id]').forEach((element) => {
          const previousId = element.getAttribute('id');
          const nextId = `${prefix}-${previousId}`;
          ids.set(previousId, nextId);
          element.setAttribute('id', nextId);
        });
        const references = ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns', 'list', 'headers'];
        content.querySelectorAll('*').forEach((element) => {
          references.forEach((attribute) => {
            if (element.hasAttribute(attribute)) {
              element.setAttribute(attribute, element.getAttribute(attribute).split(/\s+/).map((id) => ids.get(id) || id).join(' '));
            }
          });
          const href = element.getAttribute('href');
          if (href?.startsWith('#') && ids.has(href.slice(1))) element.setAttribute('href', `#${ids.get(href.slice(1))}`);
        });
      }
    }

    window.customElements.define('wishlist-quick-buy-modal', WishlistQuickBuyModal);
  });
})();
